export const LogoBuilderActionTypes = {
  LOGO_BUILDER_AVAILABILITY_REQUEST: 'LOGO_BUILDER_AVAILABILITY_REQUEST',
  LOGO_BUILDER_AVAILABILITY_SUCCESS: 'LOGO_BUILDER_AVAILABILITY_SUCCESS',
  LOGO_BUILDER_AVAILABILITY_FAILURE: 'LOGO_BUILDER_AVAILABILITY_FAILURE',
  LOGO_BUILDER_AVAILABILITY_SET: 'LOGO_BUILDER_AVAILABILITY_SET',
  LOGO_BUILDER_LOADING: 'LOGO_BUILDER_LOADING',
  LOGO_BUILDER_LOGO_GENERATION_REQUEST: 'LOGO_BUILDER_LOGO_GENERATION_REQUEST',
  LOGO_BUILDER_LOGO_GENERATION_SUCCESS: 'LOGO_BUILDER_LOGO_GENERATION_SUCCESS',
  LOGO_BUILDER_LOGO_GENERATION_FAILURE: 'LOGO_BUILDER_LOGO_GENERATION_FAILURE',
  LOGO_BUILDER_CLICKED_ON_MENU: 'LOGO_BUILDER_CLICKED_ON_MENU',
};
